import React from 'react'
import { cn } from '../../utils/cn'

const TONES = {
  gain:    'bg-gain-50 text-gain-700 ring-gain-100',
  loss:    'bg-loss-50 text-loss-700 ring-loss-100',
  accent:  'bg-accent-50 text-accent-700 ring-accent-100',
  warning: 'bg-amber-50 text-amber-700 ring-amber-100',
  neutral: 'bg-ink-100 text-ink-600 ring-ink-200',
  ink:     'bg-ink-900 text-white ring-ink-900',
}

const DOTS = {
  gain: 'bg-gain-500', loss: 'bg-loss-500', accent: 'bg-accent-500',
  warning: 'bg-amber-500', neutral: 'bg-ink-400', ink: 'bg-white',
}

/**
 * Pill — a compact status chip. Tone drives color; optional leading dot or icon.
 *   <Pill tone="gain" dot>Live</Pill>
 *   <Pill tone="accent" icon={Sparkles}>Risk-aware</Pill>
 */
export default function Pill({ tone = 'neutral', dot = false, icon: Icon, children, className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ring-inset',
        TONES[tone] || TONES.neutral,
        className,
      )}
    >
      {dot && <span className={cn('w-1.5 h-1.5 rounded-full', DOTS[tone])} />}
      {Icon && <Icon className="w-3.5 h-3.5" />}
      {children}
    </span>
  )
}
